import styled from "styled-components";
import { responsive } from "../../utils/style";
import RitualLogo from "./RitualLogo";
import MagicLink from "../MagicLink";
import { Icons, CartIcons } from "../../utils/react-svg";

const HeaderWrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 110;
  background-color: var(--white);
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
`;

const HeaderContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 16px;
  max-width: 100%;

  ${responsive.sm`
    height: 64px;
    padding: 0 24px;
  `}

  ${responsive.md`
    padding: 0 32px;
  `}
`;

const LeftLinks = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 16px;
    width: 51px;

    ${responsive.sm`
      height: 18px;
      width: 58px;
    `}

    ${responsive.md`
      height: 22px;
      width: 70px;
    `}
  }
`;

const RightLinks = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`;

const ShopAllLink = styled(MagicLink)`
  color: var(--indigo-blue);
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

const AccountLink = styled(MagicLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--indigo-blue);
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`;

const AccountIconStyled = styled(Icons.Account)`
  display: block;
  height: 20px;
  width: 21px;

  ${responsive.md`
    height: 24px;
    width: 25px;
  `}
`;

const CartLink = styled(MagicLink)`
  display: flex;
  align-items: center;
  color: var(--indigo-blue);
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }

  svg {
    height: 20px;
    width: 20px;

    ${responsive.md`
      height: 24px;
      width: 24px;
    `}
  }
`;

const SimpleHeader = () => {
  return (
    <HeaderWrapper>
      <HeaderContainer>
        <LeftLinks>
          <ShopAllLink to={`https://ritual.com/shop/all`}>Shop all</ShopAllLink>
        </LeftLinks>
        <LogoWrapper>
          <RitualLogo to={"https://ritual.com"} title="Ritual" />
        </LogoWrapper>
        <RightLinks>
          <AccountLink href={"https://account.ritual.com"} ariaLabel="Account">
            <AccountIconStyled />
          </AccountLink>
          <CartLink href={`https://ritual.com/cart`} ariaLabel="Cart">
            <CartIcons.CartBagEmpty />
          </CartLink>
        </RightLinks>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default SimpleHeader;
